import {AssetImageMap} from 'types'
import {getCDNBaseUrl} from '../../../utils/environment/EnvirontmentHelper'

export const IMAGE_ASSET = <T extends keyof AssetImageMap>(
  type: T,
  file: AssetImageMap[T],
) => `${getCDNBaseUrl()}/${type}/${file}`
